import { createStyles } from '@material-ui/core';
export default (function (theme) {
  return createStyles({
    title: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      margin: 0,
      padding: theme.spacing(2)
    },
    titleSlim: {
      padding: theme.spacing(1, 2)
    },
    buttons: {
      borderTop: "1px solid ".concat(theme.palette.divider)
    },
    buttonLeftIcon: {
      marginRight: theme.spacing(1)
    },
    titleWithClose: {
      paddingRight: 64
    },
    close: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    closeSlim: {
      top: 6
    },
    content: {
      padding: theme.spacing(2)
    },
    loading: {
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(255,255,255,0.7)'
    }
  });
});